angular.module('tgaAdmin').directive('emptyToNull', () => ({
  restrict: 'A',
  require: 'ngModel',
  link($scope, $element, attrs, ngModel) {
    ngModel.$parsers.push(function (value) {
      return value === '' ? null : value;
    });

    ngModel.$formatters.push(function (value) {
      return value === null ? '' : value;
    });
  },
}));
